// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Data_Id$Coronate from "./Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.res.js";

function fromPath(x) {
  if (!x) {
    return "Players";
  }
  switch (x.hd) {
    case "" :
        if (x.tl) {
          return ;
        } else {
          return "Players";
        }
    case "crosstable" :
        if (x.tl) {
          return ;
        } else {
          return "Crosstable";
        }
    case "round" :
        var match = x.tl;
        if (!match) {
          return ;
        }
        if (match.tl) {
          return ;
        }
        var y = Belt_Int.fromString(match.hd);
        if (y !== undefined) {
          return {
                  TAG: "Round",
                  _0: y
                };
        } else {
          return ;
        }
    case "scores" :
        if (x.tl) {
          return ;
        } else {
          return "Scores";
        }
    case "setup" :
        if (x.tl) {
          return ;
        } else {
          return "Setup";
        }
    case "status" :
        if (x.tl) {
          return ;
        } else {
          return "Status";
        }
    default:
      return ;
  }
}

function toString(id, subPage) {
  if (typeof subPage === "object") {
    return Data_Id$Coronate.toString(id) + "/round/" + String(subPage._0);
  }
  switch (subPage) {
    case "Players" :
        return Data_Id$Coronate.toString(id) + "/";
    case "Scores" :
        return Data_Id$Coronate.toString(id) + "/scores";
    case "Crosstable" :
        return Data_Id$Coronate.toString(id) + "/crosstable";
    case "Setup" :
        return Data_Id$Coronate.toString(id) + "/setup";
    case "Status" :
        return Data_Id$Coronate.toString(id) + "/status";
    
  }
}

function toString$1(x) {
  if (typeof x === "object") {
    if (x.TAG === "Tournament") {
      return "/tourneys/" + toString(x._0, x._1);
    } else {
      return "/players/" + Data_Id$Coronate.toString(x._0);
    }
  }
  switch (x) {
    case "TournamentList" :
        return "/tourneys";
    case "PlayerList" :
        return "/players";
    case "TimeCalculator" :
        return "/timecalc";
    case "Options" :
        return "/options";
    case "Index" :
    case "NotFound" :
        return "/";
    
  }
}

function useUrl() {
  var match = RescriptReactRouter.useUrl(undefined, undefined);
  var x = match.path;
  if (!x) {
    return "Index";
  }
  switch (x.hd) {
    case "options" :
        if (x.tl) {
          return "NotFound";
        } else {
          return "Options";
        }
    case "players" :
        var match$1 = x.tl;
        if (match$1) {
          if (match$1.tl) {
            return "NotFound";
          } else {
            return {
                    TAG: "Player",
                    _0: Data_Id$Coronate.fromString(match$1.hd)
                  };
          }
        } else {
          return "PlayerList";
        }
    case "timecalc" :
        if (x.tl) {
          return "NotFound";
        } else {
          return "TimeCalculator";
        }
    case "tourneys" :
        var match$2 = x.tl;
        if (!match$2) {
          return "TournamentList";
        }
        var page = fromPath(match$2.tl);
        if (page !== undefined) {
          return {
                  TAG: "Tournament",
                  _0: Data_Id$Coronate.fromString(match$2.hd),
                  _1: page
                };
        } else {
          return "NotFound";
        }
    default:
      return "NotFound";
  }
}

function Router$Link(props) {
  var onClick = props.onClick;
  var path = useUrl();
  var href = toString$1(props.to_);
  return React.cloneElement(JsxRuntime.jsx("a", {
                  children: props.children,
                  href: href,
                  onClick: (function ($$event) {
                      if (onClick !== undefined) {
                        onClick($$event);
                      }
                      if (!$$event.defaultPrevented) {
                        $$event.preventDefault();
                        return RescriptReactRouter.push(href);
                      }
                      
                    }),
                  onDragStart: props.onDragStart
                }), {
              "aria-current": href === toString$1(path)
            });
}

var Link = {
  make: Router$Link
};

var TourneyPage = {};

export {
  TourneyPage ,
  useUrl ,
  Link ,
}
/* react Not a pure module */
